import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import {
  ReportingServiceCapabilities,
  GetDonationReportType,
  GetParticipantDataReportType
} from './reportingService.types'

export const reportingService = ({ percentClient }: ReportingServiceCapabilities) => ({
  getDonationReport: ({ start, end, status, kinds, query, fundraiserId }: GetDonationReportType): Promise<string> =>
    percentClient
      .get(`${baseUrl}reporting/donations`, {
        params: {
          start,
          end,
          status,
          kinds,
          search: query,
          fundraiserId
        },
        responseType: 'blob'
      })
      .then(({ data }) => data),
  getParticipantDataReport: ({ opportunityId }: GetParticipantDataReportType): Promise<Blob> =>
    percentClient
      .get(`${baseUrl}partner/opportunities/${opportunityId}/participant-data`, {
        responseType: 'blob'
      })
      .then(({ data }) => data)
})
